import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "store";

interface AuthState {
  openFocusModal: boolean;
  unsavedAnnotations: boolean;
  isUnsaveModalOpen: boolean;
}

const initialState: AuthState = {
  openFocusModal: false,
  unsavedAnnotations: false,
  isUnsaveModalOpen: false,
};

const focusModalSlice = createSlice({
  name: "FocusModal",
  initialState,
  reducers: {
    setIsFocusModalOpen: (state, action) => {
      state.openFocusModal = action.payload;
    },
    setUnsavedAnnotations: (state, action) => {
      state.unsavedAnnotations = action.payload;
    },
    setIsUnsaveModalOpen: (state, action) => {
      state.isUnsaveModalOpen = action.payload;
    },
  },
});

export const { setIsFocusModalOpen, setUnsavedAnnotations, setIsUnsaveModalOpen } = focusModalSlice.actions;
export const openFocusModal = (state: RootState) => state.focusModal.openFocusModal;
export const unsavedAnnotations = (state: RootState) => state.focusModal.unsavedAnnotations;
export const isUnsaveModalOpen = (state: RootState) => state.focusModal.isUnsaveModalOpen;
export default focusModalSlice;
